export default function (value) {
  const string = Object.prototype.toString.call(value);
  const re = /\s[A-Z][a-z]+/g;
  const result = re.exec(string);
  let type = result[0].slice(1);

  if (Number.isNaN(value)) {
    type = 'NaN';
  }
  
  return type.toLowerCase();
}